import Icon from '@/components/Icon';
import { Stack } from '@mantine/core';
import { FunctionComponent } from 'react';
import { presentUsPhoneNumber } from '@/lib/formatters/telephone';
import classes from './SupportContactCard.module.css';

export interface SupportContactCardProps {
  email?: string;
  phoneNumber?: string;
  title: string;
}

const SupportContactCard: FunctionComponent<SupportContactCardProps> = ({
  email,
  phoneNumber,
  title,
}) => {
  return (
    <Stack className={classes.root}>
      <h1 className={classes.title}>{title}</h1>

      {phoneNumber && (
        <a className={classes.link} href={`tel:${phoneNumber}`}>
          <dl className={classes.dl}>
            <dt>
              <Icon
                alt="Telephone Number"
                meaning="neutral"
                name="feather/phone"
              />
            </dt>
            <dd>{presentUsPhoneNumber(phoneNumber)}</dd>
          </dl>
        </a>
      )}

      {email && (
        <a className={classes.link} href={`mailto:${email}`}>
          <dl className={classes.dl}>
            <dt>
              <Icon alt="Email" meaning="neutral" name="feather/mail" />
            </dt>
            <dd>{email}</dd>
          </dl>
        </a>
      )}
    </Stack>
  );
};

export default SupportContactCard;
